import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class DataUtils {
  public formatarDataFilterComHorario(data: any): Date {
    if (!data) return;

    let tempData = this.tratarDataFilterComHorario(data);
    let newDate = new Date();
    newDate.setDate(tempData.day);
    newDate.setMonth(tempData.month - 1);
    newDate.setFullYear(tempData.year);
    newDate.setHours(tempData.hora);
    newDate.setMinutes(tempData.minuto);
    newDate.setSeconds(tempData.segundo);
    return newDate;
  }

  tratarDataFilterComHorario(data) {
    let tempData = JSON.parse(JSON.stringify(data));
    if (tempData.match(/[/-]/g)) {
      let datas = tempData.split(/[/-]/g);
      let tmp = datas[2].split(' ', 3);
      let horario = tmp[1].split(':', 3);
      tempData = {
        year: Number(tmp[0]),
        month: Number(datas[1]),
        day: Number(datas[0]),

        hora: Number(horario[0]),
        minuto: Number(horario[1]),
        segundo: Number(horario[2]),
      };
    }
    return tempData;
  }

  public formatarDataFilter(data: any): Date {
    if (!data) return;

    let tempData = this.tratarDataFilter(data);
    let newDate = new Date(tempData.year, tempData.month - 1, tempData.day);

    return newDate;
  }

  tratarDataFilter(data) {
    let tempData = JSON.parse(JSON.stringify(data));
    if (tempData.match(/[/-]/g)) {
      let datas = tempData.split(/[/-]/g);
      tempData = {
        year: Number(datas[2]),
        month: Number(datas[1]),
        day: Number(datas[0]),
      };
    }
    return tempData;
  }

  daysBetween(primeiro, segundo) {
    let d1 = new Date(
      primeiro.getFullYear(),
      primeiro.getMonth(),
      primeiro.getDate()
    );
    let d2 = new Date(
      segundo.getFullYear(),
      segundo.getMonth(),
      segundo.getDate()
    );

    var millisecondosPorDia = 1000 * 60 * 60 * 24;
    var millisBetween = d2.getTime() - d1.getTime();
    var dias = millisBetween / millisecondosPorDia;

    return Math.floor(dias);
  }

  getStringDataFormatoPTBR(stringDate: string) {
    return new Date(stringDate).toLocaleString('pt-BR');
  }

  public formatarData(data: Date, locale: string): string {
    const parteData = data.toLocaleDateString(locale, { day: '2-digit', month: '2-digit', year: 'numeric' });
    const parteHora = data.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
    return `${parteData} ${parteHora}`;
  }
}
